@if (clientSystemLink.authenticationTokenType === 'none') {
  <a [href]="clientSystemLink.members[0].url" target="_blank" class="kgr-verticalMenu__item is-level-1">
    <span class="kgr-verticalMenu__itemIcon icon">
      @if (clientSystemLink.icon) {
        <svg [kgrIcon]="clientSystemLink.icon" [small]="true"></svg>
      }
      @if (clientSystemLink.iconImageFile) {
        <img [src]="clientSystemLink.iconImageFile | addApiHost" alt="Icon" />
      }
    </span>
    <span class="kgr-verticalMenu__itemLabel">{{ clientSystemLink.label }}</span>
  </a>
} @else {
  <button (click)="toggleDropdown()" class="userDropdownToggle kgr-verticalMenu__item is-level-1 kgr-clickable">
    <span class="kgr-verticalMenu__itemIcon icon">
      @if (clientSystemLink.icon) {
        <svg [kgrIcon]="clientSystemLink.icon" [small]="true"></svg>
      }
      @if (clientSystemLink.iconImageFile) {
        <img [src]="clientSystemLink.iconImageFile | addApiHost" alt="Icon" />
      }
    </span>
    <span class="kgr-verticalMenu__itemLabel">{{ clientSystemLink.label }}</span>
    <svg kgrIcon="arrow-down" class="kgr-verticalMenu__itemAddendum kgr-icon"></svg>
  </button>
  <div class="kgr-collapsible" [class.is-open]="open()">
    <div class="kgr-collapsible__content">
      @for (clientSystemLinkMember of clientSystemLink.members; track clientSystemLinkMember) {
        @if (userService.getUserStream(clientSystemLinkMember.memberId) | async; as user) {
          <a [href]="clientSystemLinkMember.url" class="kgr-verticalMenu__item is-level-2">
            <span class="kgr-verticalMenu__itemIcon">
              <kgr-profile-image
                [imageUrl]="
                  user.hasProfileImage ? (user.profileImageApiUrl | apiImageUrl: 'profile_image_m' : user._cacheBuster | async) : null
                "
                [gender]="user.gender"
                [extraSmall]="true"
              ></kgr-profile-image>
            </span>
            <span class="kgr-verticalMenu__itemLabel">{{ user.fullName }}</span>
          </a>
        }
      }
    </div>
  </div>
}
